export default function CustomSolution() {
  const features = [
    {
      icon: 'ri-search-eye-line',
      title: '고객 환경 분석',
      desc: '업무 흐름과 요구사항을 정확히 파악하여 문제의 본질을 이해합니다.',
    },
    {
      icon: 'ri-draft-line',
      title: '설계 프로세스',
      desc: '고객 환경에 최적화된 솔루션 구조를 설계하고 기술 스택을 선정합니다.',
    },
    {
      icon: 'ri-code-box-line',
      title: '개발 및 실증',
      desc: '단계별 개발과 테스트를 통해 현장에서 작동하는 시스템을 구현합니다.',
    },
    {
      icon: 'ri-loop-right-line',
      title: '유지·확장 전략',
      desc: '지속적인 모니터링과 개선을 통해 시스템의 안정성과 확장성을 보장합니다.',
    },
  ];

  const solutions = [
    {
      title: '데이터 수집·분석 시스템',
      desc: '다양한 소스의 데이터를 수집하고 분석하여 인사이트를 도출하는 맞춤형 시스템',
      tags: ['데이터 파이프라인', '실시간 분석', '시각화'],
    },
    {
      title: '업무 자동화 솔루션',
      desc: '반복적인 업무 프로세스를 자동화하여 생산성을 향상시키는 시스템',
      tags: ['프로세스 자동화', 'RPA', '워크플로우'],
    },
    {
      title: '통합 관리 플랫폼',
      desc: '분산된 시스템과 데이터를 통합하여 효율적으로 관리하는 플랫폼',
      tags: ['시스템 통합', 'API 연동', '대시보드'],
    },
  ];

  const process = [
    { step: '01', title: '요구사항 분석', desc: '고객 환경 및 업무 흐름 파악' },
    { step: '02', title: '솔루션 설계', desc: '맞춤형 아키텍처 및 기술 선정' },
    { step: '03', title: '개발 및 테스트', desc: '단계별 구현 및 검증' },
    { step: '04', title: '배포 및 운영', desc: '현장 적용 및 지속적 개선' },
  ];

  return (
    <section className="py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-20">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#0F766E]/10 border border-[#0F766E]/20 mb-6">
            <span className="text-sm font-medium text-[#0F766E]">Service 03</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 leading-tight mb-6">
            Custom Solution
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl leading-relaxed">
            기술보다 중요한 것은<br />
            현장에 맞는 적용입니다.
          </p>
          <p className="text-lg text-gray-600 max-w-3xl leading-relaxed mt-4">
            4-lab은 고객의 환경과 업무 흐름을 이해하고<br />
            그에 맞는 맞춤형 솔루션을 설계·개발합니다.
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-6 mb-20">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-[#F0FDFA] rounded-lg p-8 border border-[#99F6E4]/30"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mb-6">
                <i className={`${feature.icon} text-2xl text-[#0D9488]`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>

        <div className="mb-20">
          <h3 className="text-2xl font-bold text-gray-900 mb-10">솔루션 유형</h3>
          <div className="grid md:grid-cols-3 gap-6">
            {solutions.map((solution, index) => (
              <div
                key={index}
                className="bg-[#F0FDFA] rounded-lg p-8 border border-[#99F6E4]/30"
              >
                <h4 className="text-lg font-bold text-gray-900 mb-3">{solution.title}</h4>
                <p className="text-sm text-gray-600 mb-6 leading-relaxed">{solution.desc}</p>
                <div className="flex flex-wrap gap-2">
                  {solution.tags.map((tag, tagIndex) => (
                    <span
                      key={tagIndex}
                      className="px-3 py-1 bg-white text-xs font-medium text-[#0F766E] rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-2xl font-bold text-gray-900 mb-10 text-center">개발 프로세스</h3>
          <div className="grid md:grid-cols-4 gap-6">
            {process.map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#0F766E] text-white text-xl font-bold mx-auto mb-4">
                  {item.step}
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h4>
                <p className="text-sm text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
